import { Component, Input } from '@angular/core';
export var StoreLogMonitorComponent = (function () {
    function StoreLogMonitorComponent() {
        this.toggleCommand = 'ctrl-h';
        this.positionCommand = 'ctrl-m';
        this.expandEntries = false;
    }
    StoreLogMonitorComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ngrx-store-log-monitor',
                    template: "\n    <dock-monitor [toggleCommand]=\"toggleCommand\" [positionCommand]=\"positionCommand\">\n      <log-monitor [expandEntries]=\"expandEntries\"></log-monitor>\n    </dock-monitor>\n  "
                },] },
    ];
    /** @nocollapse */
    StoreLogMonitorComponent.ctorParameters = [];
    StoreLogMonitorComponent.propDecorators = {
        'toggleCommand': [{ type: Input },],
        'positionCommand': [{ type: Input },],
        'expandEntries': [{ type: Input },],
    };
    return StoreLogMonitorComponent;
}());
//# sourceMappingURL=store-log-monitor.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ngrx/store-log-monitor/src/store-log-monitor.js
// module id = 9r1b
// module chunks = 4